import { useState } from 'react';
import { Stepper, Step, StepLabel, StepContent, Typography } from '@mui/material';

const PackageItinerary = ({ itinerary }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [expandedSteps, setExpandedSteps] = useState({ 0: true });

  if (!itinerary?.length) return null;

  // Ordenar el itinerario por el campo order
  const sortedItinerary = [...itinerary].sort((a, b) => a.order - b.order);

  const handleNext = () => {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
    // Cerrar todos los pasos y abrir solo el siguiente
    setExpandedSteps({ [nextStep]: true });
  };

  const handleBack = () => {
    const prevStep = activeStep - 1;
    setActiveStep(prevStep);
    // Cerrar todos los pasos y abrir solo el anterior
    setExpandedSteps({ [prevStep]: true });
  };

  const handleClose = () => {
    // Cerrar todos los pasos
    setExpandedSteps({});
    setActiveStep(-1);
  };

  const handleStepClick = (stepIndex) => {
    setActiveStep(stepIndex);
    // Cerrar todos los pasos y abrir solo el seleccionado
    setExpandedSteps({ [stepIndex]: true });
  };

  return (
    <div className='package-itinerary'>
      <h3 className='package-itinerary__title'>Itinerario</h3>
      <Stepper
        activeStep={activeStep}
        nonLinear
        orientation='vertical'
        sx={{
          '& .MuiStepConnector-line': {
            minHeight: '50px',
          },
          '& .MuiStepConnector-root:last-child .MuiStepConnector-line': {
            display: 'none',
          },
        }}
      >
        {sortedItinerary.map((step, index) => (
          <Step
            active={activeStep === index}
            completed={activeStep > index}
            expanded={expandedSteps[index]}
            key={step.id}
          >
            <StepLabel onClick={() => handleStepClick(index)}>
              <Typography variant='h6'>{step.title}</Typography>
            </StepLabel>
            <StepContent>
              <div
                className='itinerary-step__content'
                dangerouslySetInnerHTML={{ __html: step.description }}
              />
              <div className='itinerary-step__actions'>
                {index > 0 && (
                  <button
                    className='itinerary-step__button itinerary-step__button--back'
                    onClick={handleBack}
                  >
                    Anterior
                  </button>
                )}
                {index === sortedItinerary.length - 1 ? (
                  <button
                    className='itinerary-step__button itinerary-step__button--next'
                    onClick={handleClose}
                  >
                    Cerrar
                  </button>
                ) : (
                  <button
                    className='itinerary-step__button itinerary-step__button--next'
                    onClick={handleNext}
                  >
                    Siguiente
                  </button>
                )}
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default PackageItinerary;
